import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import convertUnit from 'lib/unit'
import {Button, Modal, Paragraph, RoboyuOffer} from 'common/components'
import {useSelector} from 'lib/redux'
import {TreeLocPermissionModalProps} from './TreeFototreeModalProps'

const StyledModal = styled(Modal)`
  position: relative;
  width: ${convertUnit(335)};
  padding: ${convertUnit(20)};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const StyledButton = styled(Button)`
  width: fill-available;
`
const StyledTitle = styled(Paragraph)`
  margin: ${convertUnit(8)};
`
const StyledContent = styled(Paragraph)`
  margin: ${convertUnit(12)};
`
const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${convertUnit(8)};
  width: 100%;
`
const StyledRoboyuContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: ${convertUnit(136)};
  max-width: ${convertUnit(136)};
  display: flex;
  justify-content: center;
  align-self: center;
`

export default function TreeLocPermissionModal({
  toggleModal,
  visible,
}: TreeLocPermissionModalProps) {
  const {translate} = useTranslation()
  const {colorTheme} = useSelector('roboyuState')

  return (
    <StyledModal visible={visible} onBackdropPress={toggleModal}>
      <StyledTitle fontSize="l" fontWeight="bold">
        {translate('giftShop:accessPermissionHeader')}
      </StyledTitle>
      <StyledRoboyuContainer>
        <RoboyuOffer
          width={convertUnit(136)}
          height={convertUnit(136)}
          colorTheme={colorTheme.name}
        />
      </StyledRoboyuContainer>
      <StyledContent fontSize="m">
        {translate('tree:locPermissionModalContent')}
      </StyledContent>
      <StyledButtonContainer>
        <StyledButton
          label={translate('tree:enableGPS')}
          onClick={() =>
            window.open('https://support.google.com/maps/answer/2839911')
          }
        />
        <StyledButton
          label={translate('global:cancel')}
          onClick={toggleModal}
          color="primary_5"
          backgroundColor="white_2"
        />
      </StyledButtonContainer>
    </StyledModal>
  )
}
